import { createFileRoute } from "@tanstack/react-router"
import { LoopReturnsConfiguration } from "modules/settings/components/integrations/loopReturns"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/loopReturns")({
  component: LoopReturnsConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.loopReturns.title"),
    })
  },
})
